// This file was automatically generated from appchart.dialog.plrPreview.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.plrPreview');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.app.shared.viewInlinePdf');
goog.require('el8.template.appshared.docTags');
goog.require('el8.template.ptdata.letters.attachments');
goog.require('el8.template.ptdata.model.attachment');
goog.require('el8.template.render.chartFeedItemNew');
goog.require('el8.template.render.reportFeedItem');
goog.require('el8.template.render.signOff');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.plrPreview.contentReport = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="cardDetails"><div class="reportNoteHolder"><div class="reportNotesContent"><div class="reportNotesListContainer"><div class="reportDownloadWrap">');
  if (opt_data.docTags) {
    output.append('<div class=\'doctags\'>');
    el8.template.appshared.docTags.content(soy.$$augmentData(opt_data, {docTags: opt_data.docTags, align: 'right'}), output);
    output.append('</div>');
  }
  output.append('<p class="el8SignoffText w65 ml35percent">');
  el8.template.render.signOff.summaryText(opt_data, output);
  output.append('</p></div></div></div></div>');
  el8.template.render.reportFeedItem.bodyContentReport(soy.$$augmentData(opt_data, {hasActions: false, directlyRenderImages: true}), output);
  if (opt_data.attachments && opt_data.attachments.length > 0) {
    if (opt_data.attachments.length > 1 || opt_data.resultGrids.length != 0 || opt_data.images.length != 0) {
      output.append('<div class="el8ImagePlaceHolder el8ReportImageSize"><div class="el8ImagePlaceHolderText el8ReportImageMargin">');
      var itemList2152 = opt_data.attachments;
      var itemListLen2152 = itemList2152.length;
      for (var itemIndex2152 = 0; itemIndex2152 < itemListLen2152; itemIndex2152++) {
        var itemData2152 = itemList2152[itemIndex2152];
        output.append('<a class="el8ImageLinkText" target="_blank" rel="noopener" href="', soy.$$escapeHtml(itemData2152.downloadUrl), '" tabindex="-1">');
        el8.template.ptdata.model.attachment.summary(itemData2152, output);
        output.append('</a>');
      }
      output.append('</div></div>');
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.plrPreview.contentPdf = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.app.shared.viewInlinePdf.content(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.plrPreview.contentVisitHtml = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pad10">');
  el8.template.render.chartFeedItemNew.visitNoteCore(soy.$$augmentData(opt_data.item, {directlyRenderImages: true}), output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.plrPreview.contentNonvisitHtml = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pad10">');
  el8.template.render.chartFeedItemNew.nonvisitNoteCore(soy.$$augmentData(opt_data.item, {directlyRenderImages: true}), output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.plrPreview.dialogTitle = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.letters.attachments.rawTitleText(opt_data.item, output);
  output.append(' ', (opt_data.item.signUserName) ? 'by ' + soy.$$escapeHtml(opt_data.item.signUserName) : 'shared by ' + soy.$$escapeHtml(opt_data.collab.physicianName), ' on ', (soy.$$escapeHtml(opt_data.item.chartFeedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.item.chartFeedDate)) : ''));
  if (!opt_sb) return output.toString();
};
